import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { SupplierDetails } from '@suppliers/models/supplier-details';

@Injectable()
export class SupplierDetailsHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilderService: UrlBuilderService) { }

  getDetails(supplierRef: number): Observable <SupplierDetails> {
    const url = this.urlBuilderService.getUrl(`supplier/${supplierRef}/details`);
    return this.http
      .get<SupplierDetails>(url).pipe(
        map(details => details || undefined)
      );
  }

}
